import { render, staticRenderFns } from "./InfoCardResearch.vue?vue&type=template&id=c856d5d2&scoped=true&"
import script from "./InfoCardResearch.vue?vue&type=script&lang=js&"
export * from "./InfoCardResearch.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardResearch.vue?vue&type=style&index=0&id=c856d5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c856d5d2",
  null
  
)

export default component.exports